import { useEffect, useState } from 'react';
import useQuery from './useQuery';
import {
  hasTrackedOnSession,
  PartnerNames,
  trackPageViewForPartner,
  trackPartnerActionEvent,
} from '../Analytics/utils';

export const KSOURCE = 'ksource';

const usePageViewTracking = (pageName: string, partner: PartnerNames) => {
  const query = useQuery();
  const [entryTime] = useState(new Date());
  const [actionTrackedOnVisibility, setActionTrackedOnVisibility] =
    useState(false);

  useEffect(() => {
    const ksource = query.get(KSOURCE);

    const trackTimeSpent = () => {
      const exitTime = new Date();
      const timeSpent = (exitTime.getTime() - entryTime.getTime()) / 1000 / 60;
      if (timeSpent > 0.01 && !hasTrackedOnSession(pageName, false)) {
        trackPartnerActionEvent('time_spent', partner, query, {
          PageName: pageName,
          TimeSpent: timeSpent.toFixed(2),
        });
      }
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'hidden' && !actionTrackedOnVisibility) {
        setActionTrackedOnVisibility(true);
        trackTimeSpent();
      }
    };

    if (!hasTrackedOnSession(pageName, true)) {
      trackPageViewForPartner(pageName, partner, ksource);
    }

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);

      if (!actionTrackedOnVisibility && document.visibilityState !== 'hidden') {
        setActionTrackedOnVisibility(true);
        trackTimeSpent();
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [entryTime, pageName, query, actionTrackedOnVisibility]);
};

export default usePageViewTracking;
